import React from 'react'
import RoleManagementCard from './RoleManagementCard'

const RolePermission = (props) => {

    const {
        parentMenuList,
        setSelectedParent,
        values,
        handleCheck,
        handleRedirect,
        handleSubmitValues,
        loading,
        errors,
    } = props;

    return (
        <>
            <div className="card role-permission-card">
                <div className="card-header">
                    <h2>Role Permission</h2>
                </div>
                <div className="card-body">
                    <p className="form-error">{errors?.roleCheck}</p>
                    <RoleManagementCard
                        parentMenuList={parentMenuList}
                        setSelectedParent={setSelectedParent}
                        values={values}
                        handleCheck={handleCheck}
                        errors={errors} />
                </div>
            </div>
            <div className='card'>
                <div className='card-body'>
                    <div className="row">
                        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-3 mb-3">
                            <div className="save-btns d-flex justify-content-end">
                                <button className="btn cancel-btn" onClick={handleRedirect}> Cancel </button>
                                <button className="btn save-btn" onClick={handleSubmitValues} disabled={loading}>
                                    {values?.id ? "Update" : "Save"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default RolePermission